import api from './index'
import type { PhoneValidationResult } from '@/types'

const APILAYER_URL = 'https://api.apilayer.com/number_verification/validate'
const APILAYER_KEY = '4ykhNgxn0OzSYQYq1MW7hjJYXozN4rZt'
const LAMBDA_FALLBACK_URL = 'https://isy6rbqwbqd6irk5ruqsiouuze0vjrqs.lambda-url.us-east-2.on.aws/'

export async function validatePhone(phone: string): Promise<PhoneValidationResult> {
  try {
    // Primary: APILayer
    const response = await api.get(APILAYER_URL, {
      params: { number: `1${phone}` },
      headers: { apikey: APILAYER_KEY },
      timeout: 3000,
    })

    if (!response.data) {
      return await fallbackValidation(phone)
    }

    return {
      isValid: response.data.valid,
      isUS: response.data.country_code === 'US',
    }
  } catch (error) {
    console.error('Primary phone validation error:', error)
    return await fallbackValidation(phone)
  }
}

async function fallbackValidation(phone: string): Promise<PhoneValidationResult> {
  try {
    const response = await api.get(LAMBDA_FALLBACK_URL, {
      params: { phone, type: 'fake' },
      timeout: 10000,
    })

    return {
      isValid: response.data !== 'Fake',
      isUS: true,
    }
  } catch (error) {
    console.error('Fallback phone validation error:', error)
    // On complete failure, allow through
    return { isValid: true, isUS: true }
  }
}
